import type { CategoryName } from "@/stores"
import type { Decorator } from "@/types"
import type { FileChannelString } from "@/utils/fileImport"
import type { Component } from "vue"

export const NOT_IN_FILE = -1

export enum PhaseSteps {
  UPLOAD = "Target and upload",
  SELECT = "Select",
  MATCH = "Match",
  PREVIEW = "Preview",
}

export enum MatchType {
  Time = "TimeMatch",
  Text = "TextMatch",
}

export enum ItemMatchStatus {
  PENDING,
  TO_IGNORE,
  EXISTING_MATCH,
  ALREADY_IGNORED,
  AUTO_MATCH,
  MANUAL_MATCH,
  CREATE,
  EDIT_MATCH,
}

export type MatchSummaryStatus = Map<ItemMatchStatus, number>

export interface ItemInfo {
  externalName: string
  internalName?: string
  status: ItemMatchStatus
}

export interface CategorySummary {
  categoryName: CategoryName
  decorator: Decorator
  statuses: string[]
}

export interface Step {
  title: PhaseSteps
  component: Component
  showNext: () => boolean
  decorator: () => Decorator
}

export interface MatchTab {
  id: number
  title: string
  type: MatchType
  decorator: () => Decorator
}

export interface ExternalNames {
  [P: string]: Record<string, string>
}

export interface IgnoredNames {
  [P: string]: string[]
}

export interface NotInFileMap {
  [P: string]: string
}

export interface NewNames {
  [P: string]: string[]
}

export enum ImportTargetType {
  Category,
  Dataset,
}

export interface ImportData {
  targets: string[]
  columnMap: Record<string, number>
  valueColumns: number[]
  weightingColumn?: number
  externalNames: ExternalNames
  ignoredNames: IgnoredNames
  notInFileMap: NotInFileMap
  newNames: NewNames
  dataFormat?: FileChannelString
  data: string // CSV
}

// A map key representing a single cell in a CSV. Takes the form '{rowIndex},{colIndex}'
export type CellCoord = string

export type CellErrorMsg = string

export interface EditItems {
  externalName: string
  previousName: string
  newName: string
}

export interface CSVObj {
  sheetHeaders: string[]
  headers: string[]
  rows: string[][]
}
export interface UploadFile {
  file: File
  scraped?: CSVObj
  dataAsArray: string[][]
}
